/* eslint-disable react/prop-types */

import { Helmet } from 'react-helmet';
import React from 'react';
import { connect } from 'react-redux';
import format from 'date-fns/format';

import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Section from '@zg-rentals/multibrand-ui/lib/Section';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import InquiryNotFound from '../../modules/InquiryNotFound';
import pathsManifest from '../../../pathsManifest';
import UserActions from '../../../flux/actions/UserActions';
import ListingActions from '../../../flux/actions/ListingActions';
import SurveyListingCard from '../../modules/SurveyListingCard';
import queryUtil from '../../../utils/queryUtils';
import { logError } from '@zg-rentals/log-error';

//https://hotpads.com/renter-hub/tour-feedback?allInquiryIds=1944467955245269162,1944467955245269163,1944467955245269164,1944467955245269165&allInquiryIdsHash=c49f18a972f48e51e3789ff4f8bde339&startDate=2019-04-08&endDate=2019-04-11&utm_source=tourFollowup&utm_medium=email&utm_campaign=tourFollowup&ref=tourFollowUp&nid=cd1e4c32-81b1-11e9-895e-acde48001122
const feedbackTypes = {
  YES: 14,
  NO: 15,
};

class TourFeedbackPage extends React.Component {
  constructor(props) {
    super(props);

    this.handleClickDoneButton = this.handleClickDoneButton.bind(this);
    this.handleSubmitFeedback = this.handleSubmitFeedback.bind(this);

    this.state = {
      listingsLoading: true,
      hasSubmittedFeedback: false,
      listings: [],
    };
  }

  componentDidMount() {
    const { dispatch, currentQuery } = this.props;
    const { allInquiryIds, allInquiryIdsHash } = currentQuery;
    let allInquiryIdsArr = decodeURIComponent(allInquiryIds).split(',');
    const body = {
      inquiryIds: allInquiryIdsArr,
      allInquiryIdsHash,
    };

    dispatch(ListingActions.getFeedbackListings(body))
      .then((listings) => {
        return this.setState({
          listingsLoading: false,
          listings,
          hasSubmittedFeedback: listings.some(
            (listing) =>
              listing.submittedFeedbackCode === feedbackTypes.YES || listing.submittedFeedbackCode === feedbackTypes.NO,
          ),
        });
      })
      .catch((err) => {
        logError({
          error: err,
          errorType: 'TourFeedbackPage',
          context: {
            location: 'TourFeedbackPage#componentDidMount',
          },
        });
      });
  }

  handleSubmitFeedback(type, inquiryId, hash) {
    const { hasSubmittedFeedback, listings } = this.state;

    const { dispatch } = this.props;
    for (var i in listings) {
      if (listings[i].inquiryId === inquiryId) {
        listings[i].submittedFeedbackCode = type;
      }
    }

    const feedbackBody = {
      submittedFeedbackCode: type,
      hash,
      inquiryId,
    };

    dispatch(UserActions.submitFeedbackWithoutReport(feedbackBody));

    this.setState({
      listings,
    });

    if (!hasSubmittedFeedback) {
      this.setState({
        hasSubmittedFeedback: true,
      });
    }
  }

  handleClickDoneButton() {
    const { listings } = this.state;
    let providerListingIds = 'providerListingIds=';
    let titles = 'titles=';

    listings.forEach((listing) => {
      if (listing.submittedFeedbackCode === feedbackTypes.YES) {
        providerListingIds = `${providerListingIds}${listing.aliasEncoded || ''},`;
        titles = `${titles}${listing.title || ''},`;
      }
    });

    // Remove the trailing comma
    providerListingIds = providerListingIds.replace(/,$/, '');
    titles = titles.replace(/,$/, '');

    const queryString = `${providerListingIds}&${titles}`;

    window.router.transitionTo(`${pathsManifest.tourFeedbackSuccessPage}?${queryString}`, true);
  }

  getDateRange() {
    const {
      currentQuery: { startDate, endDate },
    } = this.props;
    const startDateFormat = format(startDate, 'MMM DD');
    const endDateFormat = format(endDate, 'MMM DD');

    let dateRange = startDateFormat;

    if (startDateFormat !== endDateFormat) {
      dateRange = `${startDateFormat}${`\u2013`}${endDateFormat}`;
    }

    return dateRange;
  }

  render() {
    const { hasSubmittedFeedback, listings, listingsLoading } = this.state;
    const { brand, currentQuery } = this.props;
    const yesButtonText = 'Yes, I toured';
    const { totalListings } = currentQuery;

    if (listingsLoading) {
      return null;
    }

    return listings.length > 0 ? (
      <React.Fragment>
        <Helmet>
          <meta name="robots" content="noindex" />
          <title>Tour Feedback</title>
        </Helmet>

        <Section>
          <Center>
            <Row>
              <Col>
                <Text type="h2">Have you toured yet?</Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <Text type="body" lowlight>
                  Showing {totalListings} properties you mentioned you heard back <br />
                  from on {this.getDateRange()}.
                </Text>
              </Col>
            </Row>
          </Center>
        </Section>
        <div>
          {listings.map((listing) => {
            return (
              <Center key={listing.hash}>
                <Col sm={9} md={8} lg={7}>
                  <SurveyListingCard
                    onSubmitFeedback={this.handleSubmitFeedback}
                    listing={listing}
                    feedbackTypes={feedbackTypes}
                    yesButtonActive={listing.submittedFeedbackCode === feedbackTypes.YES}
                    noButtonActive={listing.submittedFeedbackCode === feedbackTypes.NO}
                    yesButtonText={yesButtonText}
                  />
                </Col>
              </Center>
            );
          })}
        </div>
        <Section>
          <Center className="stacked-lg">
            <Row>
              <Col>
                <Button type="primary" disabled={!hasSubmittedFeedback} onClick={this.handleClickDoneButton}>
                  Done
                </Button>
              </Col>
            </Row>
          </Center>
        </Section>
      </React.Fragment>
    ) : (
      <Section>
        <InquiryNotFound brand={brand} />
      </Section>
    );
  }
}

const mapStateToProps = (state) => ({
  currentQuery: queryUtil.parse(state.router.location.search),
  brand: state.app.brand,
  currentArea: state.area.currentArea,
  hostname: state.app.hostname,
});

export default connect(mapStateToProps)(TourFeedbackPage);
